import { useState, useEffect } from 'react';

export const useWallet = () => {
    const [account, setAccount] = useState(null);
    const [isConnecting, setIsConnecting] = useState(false);

    useEffect(() => {
        checkIfWalletIsConnected();
    }, []);

    const checkIfWalletIsConnected = async () => {
        try {
            if (!window.ethereum) return;
            const accounts = await window.ethereum.request({ method: 'eth_accounts' });
            if (accounts.length) {
                setAccount(accounts[0]);
            }
        } catch (error) {
            console.error("Lỗi kiểm tra ví:", error);
        }
    };

    const connectWallet = async () => {
        if (!window.ethereum) {
            alert("Vui lòng cài đặt MetaMask!");
            return;
        }

        try {
            setIsConnecting(true);
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            setAccount(accounts[0]);
        } catch (error) {
            console.error("Lỗi kết nối ví:", error);
        } finally {
            setIsConnecting(false);
        }
    };

    const formatAddress = (address) => {
        if (!address) return '';
        return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    };

    return { account, isConnecting, connectWallet, formatAddress };
};